<div class="home-page">
  <p-card>
    <div class="d-flex justify-content-center">
      <p-image
        src="../../../assets/images/SCG/SCG_Home_Page_BG.jfif"
        alt="SCG"
        imageClass="home-image-style2"
      ></p-image>
    </div>
  </p-card>
</div>
